import {createSlice} from "@reduxjs/toolkit";

const appSlice = createSlice ({
    name: 'app',
    initialState: {
        loading: false,
    },
    reducers: {
        startLoading: (state) => {
            state.loading = true;
        },
        stopLoading: (state) => {
            state.loading = false;
        },
    }
})

export const {startLoading,stopLoading} = appSlice.actions;

export default appSlice.reducer;